import { UNSTYLED } from './../../ricos-content';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { EditorPlugin } from './../../ricos-types';
import { createShortcut } from './../../ricos-types';

import { paragraph } from './extension';
import { paragraphConverter } from './paragraph-converter';

export const pluginParagraph: EditorPlugin = {
  type: Node_Type.PARAGRAPH,
  pmMarkConverters: [],
  pmNodeConverters: [paragraphConverter],
  shortcuts: [
    createShortcut({
      name: Node_Type.PARAGRAPH,
      description: 'ShortcutsSheet_Formatting_ParagraphFormat',
      keys: { macOs: 'Meta+Alt+0', windows: 'Ctrl+Alt+0' },
      command({ publicCommands }) {
        publicCommands.setBlockType(UNSTYLED);
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  config: {},
  tiptapExtensions: [paragraph],
};
